import { useCallback, useEffect, useState } from "react";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { useTranslation } from "react-i18next";
import { SupportedLanguage } from "@src/types/orgSettings";
import { useUpdateUser } from "@apis/user";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useSelector } from "react-redux";
import { showToast, ToastTypes } from "../VDBToast/util";

const useLanguageSelection = () => {
  const { i18n } = useTranslation();
  const { settings } = useOrgSettingsSlice();
  const [languages, setLanguages] = useState<SupportedLanguage[]>([]);
  const [selectedLanguage, setSelectedLanguage] =
    useState<SupportedLanguage | null>(null);

  const userInfo = useUserInfo();
  const { mutate } = useUpdateUser(userInfo.getUserId());
  const { t } = useTranslation();
  const installationIdentifier = useSelector(
    (state: any) => state.appState?.installationIdentifier
  );
  useEffect(() => {
    if (settings?.organization?.enable_language_translation)
      setLanguages(settings?.organization?.supported_language || []);
  }, [settings]);

  useEffect(() => {
    setNewLanguage(i18n.language);
  }, [languages]);

  const changeLanguage = useCallback(
    (lan: string | undefined) => {
      if (lan) {
        i18n.changeLanguage(lan);
        setNewLanguage(lan);
        mutate(
          {
            user: {
              preferred_language: lan,
              installation_identifier: installationIdentifier,
            },
          },
          {
            onSuccess(data: any) {
              showToast(
                t("language.toast.title.text"),
                data?.data.message,
                ToastTypes.SUCCESS,
                true,
                true
              );
            },
            onError(data: any) {
              showToast(
                undefined,
                data?.data.message,
                ToastTypes.ERROR,
                true,
                true
              );
            },
          }
        );
      }
    },
    [languages]
  );

  const setNewLanguage = (code: string) => {
    if (Array.isArray(languages) && languages.length) {
      const selLan = languages.find((lan) => lan.code === code);
      if (selLan?.code) setSelectedLanguage(selLan);
    }
  };

  const getLanguageByCode = (code: string) => {
    if (Array.isArray(languages) && languages.length) {
      const language = languages.find((lan) => lan.code === code);
      if (language?.code) return language;
      else return languages[0];
    } else return { title: "English" };
  };

  return {
    languages,
    selectedLanguage,
    changeLanguage,
    getLanguageByCode,
  };
};

export default useLanguageSelection;
